export enum ProgressType {
    PKUserMatch = 0,
    PKUserImport = 1,
    CopyTextLabels = 2,
    BalooSyncGroups = 3,
    BalooSyncUsers = 4,
    PlandayImportUnits = 5,
    PlandayImportUsers = 6,
}
